module.exports = __webpack_public_path__ + "img/rule_headimg.1f39ae56.jpg";